import { render } from "./AddRegionModal.vue?vue&type=template&id=7db6f6a2&ts=true"
import script from "./AddRegionModal.vue?vue&type=script&lang=ts"
export * from "./AddRegionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__